import { useInfiniteQuery } from '@tanstack/react-query';

import type { SchoolSearchRes } from '@/api/gen/_model/schoolSearchRes';
import { searchSchools } from '@/api/gen/school-controller/school-controller.gen';

const PAGE_SIZE = 20;

export const useSchoolSearch = (searchQuery: string, enabled: boolean) => {
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    isError,
    error,
  } = useInfiniteQuery({
    queryKey: ['schoolSearch', searchQuery],
    queryFn: async ({ pageParam }) => {
      const response = await searchSchools({
        request: {
          searchText: searchQuery,
          page: pageParam,
          limit: PAGE_SIZE,
        },
      } as any);

      return response;
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, _, lastPageParam) => {
      // 반환된 학교 수가 limit보다 작으면 마지막 페이지
      const hasMore = lastPage.data.content.length >= PAGE_SIZE;

      return hasMore ? lastPageParam + 1 : undefined;
    },
    enabled: enabled && searchQuery.length > 0,
    refetchOnWindowFocus: false,
  });

  const schools: SchoolSearchRes[] =
    data?.pages.flatMap(page => page.data.content) ?? [];

  return {
    schools,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    isError,
    error,
  };
};
